import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { processFileUpload } from 'stdjs/filepond-setup';

export function openCamera(video){

  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {

    // todo do we need to modify this based on the screen size?
    // access video stream from camera
    navigator.mediaDevices.getUserMedia({ 
      audio: false,
      video: {
        width: 1920,
        height: 1080,
        facingMode: 'environment'
      }
    }).then(function (stream) {

      if (stream.getVideoTracks().length > 0){

        window.localStream = stream;
        video.srcObject = stream;
        video.onloadedmetadata = function(e) {
          activateCamera();
          video.play();     
        }

      } else {
        console.log("error");
      }

    }).catch(e => {
        // on failure/error, alert message.         
        console.log(e);
    });
  }
}

export function closeCamera(){
  deactivateCamera();
}

export function drawCanvasImage(video, canvas, img) {

  var context = canvas.getContext("2d");
    
  try {

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    img.setAttribute('src', canvas.toDataURL('image/jpeg'));

    photoTaken();

  } catch (e) {
    // TODO
    console.log(e);
    console.log("Failed to render canvas");
  }

}

export function savePhoto(canvas, fileName, contentType, url, callback) {
  // TODO check content type here.....
  var processBlobFunction = function( blob ){
    
    let file = new File([blob], fileName, { type: contentType })
    
    processFileUpload( url, file, callback, null, null);
    
  }
  
  canvas.toBlob( processBlobFunction, contentType);
}

function activateCamera() {  
  $("#camera").removeClass("d-none");
  $("#photoPreview").addClass("d-none");
}

function photoTaken() {
  localStream.getTracks().forEach(function (track) {
    if (track.readyState == 'live' && track.kind === 'video') {
      $("#photoPreview").removeClass("d-none");
    }
  });
}

function deactivateCamera() {
  localStream.getTracks().forEach(function (track) {
    if (track.readyState == 'live' && track.kind === 'video') {
      track.stop();
      $("#camera").addClass("d-none");
      $("#photoPreview").addClass("d-none");
    }
  });
}
